import { Box, Flex, Image, Stack } from "@chakra-ui/react";
import { H1 } from 'view-layer/styled/html';
import { phoneFormat } from 'business-layer/helpers/phoneFormat';

import { HouseIcon, PhoneIcon, EmailIcon } from './AddressIcon';


interface PropertyInfoData {
  propertyLogo: string,
  propertyName: string,
  address1: string,
  address2: string,
  city: string,
  country: string,
  phone: string,
  email: string,
}

type Props = { data: PropertyInfoData };

export const PropertyInfo = ({ data }: Props): JSX.Element => (
  <Box p={10} pr={16}>
    {data.propertyLogo && <Box h="100px" mb={10}>
      <Image maxHeight="120" src={data.propertyLogo} data-testid="property-logo" borderRadius={'20px'}/>
    </Box>}

    <H1 data-testid="property-title">{data.propertyName}</H1>
    <Stack mt={6} pb={6} direction={'column'} justify={'space-between'} align={'stretch'} gap={4}>
      <Flex gap={2}>
        <Box flex={'0 0 20px'}><HouseIcon /></Box>
        <Box fontSize={'sm'}>
          {data.address1 && <span data-testid="property-address1">{data.address1}<br /></span>}
          {data.address2 && <span data-testid="property-address2">{data.address2}<br /></span>}
          {data.city && <span data-testid="property-city">{data.city}<br /></span>}
          {data.country && <span data-testid="property-country">{data.country}</span>}
        </Box>
      </Flex>
      <Flex data-testid="property-phone" gap={2}>
        <Box flex={'0 0 20px'}><PhoneIcon /></Box>
        <Box fontSize={'sm'}>{phoneFormat(data.phone)}</Box>
      </Flex>
      <Flex data-testid="property-email" gap={2}>
        <Box flex={'0 0 20px'}><EmailIcon /></Box>
        <Box fontSize={'sm'}>{data.email}</Box>
      </Flex>
    </Stack>
  </Box>
)